import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import FeesTable from './FeesTable';

function FeesContainer({ match, pathName }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['EBPLS FEES SETTING VIEW PLANNING']) && (
                <li className="nav-item">
                  <Link
                    to="/ebpls/settings/fees/planning"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('ebpls/settings/fees/planning') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Planning
                  </Link>
                </li>
              )}
              {Acl(permissions, ['EBPLS FEES SETTING VIEW ENGINEERING']) && (
                <li className="nav-item">
                  <Link
                    to="/ebpls/settings/fees/engineering"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('ebpls/settings/fees/engineering') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Engineering
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/planning`} />}
          />
          {Acl(permissions, ['EBPLS FEES SETTING VIEW PLANNING']) && (
            <Route
              path={`${match.path}/planning`}
              render={() => <FeesTable type="planning" />}
            />
          )}
          {Acl(permissions, ['EBPLS FEES SETTING VIEW ENGINEERING']) && (
            <Route
              path={`${match.path}/engineering`}
              render={() => <FeesTable type="engineering" />}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

FeesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(FeesContainer);
